// extracted by mini-css-extract-plugin
export default {"changeLink":"MQ-z","disabled":"NQ-z","inline":"OQ-z"};